import { Locale } from 'chaika-enums';
export const treatmentPlan = {
    scheduledAtThisAppointment: {
        [Locale.Ru]: 'Назначено на этом приеме',
        [Locale.Am]: 'Նշանակված է այս ընդունելության ժամանակ',
        [Locale.En]: 'Scheduled at this appointment',
        [Locale.Pt]: 'Agendado nesta consulta',
        [Locale.Ge]: 'დაგეგმილია ამ მიღებაზე',
    },
    entryRecord: {
        [Locale.Ru]: 'Запись в карте',
        [Locale.Am]: 'Գրառում քարտում',
        [Locale.En]: 'Entry',
        [Locale.Pt]: 'Entrada',
        [Locale.Ge]: 'შესვლის რუკაზე',
    },
    selectedServicesPrice: {
        [Locale.Ru]: 'Стоимость выбранных услуг',
        [Locale.Am]: 'Ընտրված ծառայությունների արժեք',
        [Locale.En]: 'Selected services price',
        [Locale.Pt]: 'Preço dos serviços selecionados',
        [Locale.Ge]: 'შერჩეული მომსახურების ღირებულება',
    },
    totalCost: {
        [Locale.Ru]: 'Общая стоимость',
        [Locale.Am]: 'Ընդհանուր արժեք',
        [Locale.En]: 'Total cost',
        [Locale.Pt]: 'Custo total',
        [Locale.Ge]: 'საერთო ღირებულება',
    },
    currentCost: {
        [Locale.Ru]: 'Текущая стоимость',
        [Locale.Am]: 'Ընթացիկ արժեք',
        [Locale.En]: 'Current cost',
        [Locale.Pt]: 'Custo atual',
        [Locale.Ge]: 'მიმდინარე ღირებულება',
    },
    costPerMonth: {
        [Locale.Ru]: 'Стоимость в месяц',
        [Locale.Am]: 'Արժեքն ամսական',
        [Locale.En]: 'Cost per month',
        [Locale.Pt]: 'Custo por mês',
        [Locale.Ge]: 'Cost per month',
    },
    howLongIsPriceValid: {
        [Locale.Ru]: 'Сколько действует цена',
        [Locale.Am]: 'Որքան է գործում գինը',
        [Locale.En]: 'How long is the price valid',
        [Locale.Pt]: 'Quanto tempo o preço é válido',
        [Locale.Ge]: 'How long is the price valid',
    },
    totalCostTreatmentPlan: {
        [Locale.Ru]: 'Общая стоимость плана лечения',
        [Locale.Am]: 'Բուժման պլանի ընդհանուր արժեք',
        [Locale.En]: 'Total cost of the treatment plan',
        [Locale.Pt]: 'Custo total do plano de tratamento',
        [Locale.Ge]: 'მკურნალობის გეგმის საერთო ღირებულება',
    },
    toBePaidByPatient: {
        [Locale.Ru]: 'К оплате пациентом',
        [Locale.Am]: 'Վճարման ենթակա պացիենտի կողմից',
        [Locale.En]: 'To be paid by the patient',
        [Locale.Pt]: 'A ser pago pelo paciente',
        [Locale.Ge]: 'უნდა გადაიხადოს პაციენტის მიერ',
    },
    futurePatientPayments: {
        [Locale.Ru]: 'Сумма будущих затрат',
        [Locale.Am]: 'Ապագա ծախսերի գումար',
        [Locale.En]: 'Future patient payments',
        [Locale.Pt]: 'Pagamentos futuros do paciente',
        [Locale.Ge]: 'მომავალი პაციენტის გადასახადები',
    },
    changePrograms: {
        [Locale.Ru]: 'Изменить программы и скидки',
        [Locale.Am]: 'Փոփոխել ծրագրերը և զեղչերը',
        [Locale.En]: 'Change programs and discounts',
        [Locale.Pt]: 'Alterar programas e descontos',
        [Locale.Ge]: 'პროგრამებისა და ფასდაკლებების შეცვლა',
    },
    changeProgramsSecond: {
        [Locale.Ru]: 'Изменение программы и скидки',
        [Locale.Am]: 'Ծրագրի և զեղչի փոփոխում',
        [Locale.En]: 'Program changes and discounts',
        [Locale.Pt]: 'Alterações de programas e descontos',
        [Locale.Ge]: 'პროგრამის ცვლილებები და ფასდაკლებები',
    },
    selectReferralsToChangeConditions: {
        [Locale.Ru]: 'Выберите направления, для которых хотите изменить условия',
        [Locale.Am]: 'Ընտրեք ուղեգրերը, որոնց համար ցանկանում եք փոփոխել պայմանները',
        [Locale.En]: 'Select the directions for which you want to change the conditions',
        [Locale.Pt]: 'Selecione as direções para as quais deseja alterar as condições',
        [Locale.Ge]: 'აირჩიეთ მიმართულებები, რომლისთვისაც გსურთ პირობების შეცვლა',
    },
    addDiscount: {
        [Locale.Ru]: 'Добавить скидку',
        [Locale.Am]: 'Ավելացնել զեղչ',
        [Locale.En]: 'Add discount',
        [Locale.Pt]: 'Adicionar desconto',
        [Locale.Ge]: 'ფასდაკლების დამატება',
    },
    withoutDiscount: {
        [Locale.Ru]: 'Без скидки',
        [Locale.Am]: 'Առանց զեղչի',
        [Locale.En]: 'No discount',
        [Locale.Pt]: 'Sem desconto',
        [Locale.Ge]: 'ფასდაკლება არ არის',
    },
    withoutProgram: {
        [Locale.Ru]: 'Без программы',
        [Locale.Am]: 'Առանց ծրագրի',
        [Locale.En]: 'Without program',
        [Locale.Pt]: 'Sem programa',
        [Locale.Ge]: 'პროგრამის გარეშე',
    },
    withoutService: {
        [Locale.Ru]: 'Без услуг',
        [Locale.Am]: 'Առանց ծառայությունների',
        [Locale.En]: 'Without service',
        [Locale.Pt]: 'Sem serviço',
        [Locale.Ge]: 'მომსახურების გარეშე',
    },
    withoutInsurance: {
        [Locale.Ru]: 'Без страховки',
        [Locale.Am]: 'Առանց ապահովագրության',
        [Locale.En]: 'Without insurance',
        [Locale.Pt]: 'Sem seguro',
        [Locale.Ge]: 'დაზღვევის გარეშე',
    },
    insuranceOrganization: {
        [Locale.Ru]: 'Страховая организация',
        [Locale.Am]: 'Ապահովագրական կազմակերպություն',
        [Locale.En]: 'Insurance organization',
        [Locale.Pt]: 'Organização de seguros',
        [Locale.Ge]: 'სადაზღვევო კომპანია',
    },
    percents: {
        [Locale.Ru]: 'В процентах',
        [Locale.Am]: 'Տոկոսներով',
        [Locale.En]: 'As a percentage',
        [Locale.Pt]: 'Como uma porcentagem',
        [Locale.Ge]: 'პროცენტულად',
    },
    rubles: {
        [Locale.Ru]: 'В рублях',
        [Locale.Am]: 'Ռուբլով',
        [Locale.En]: 'In rubles',
        [Locale.Pt]: 'Em rublos',
        [Locale.Ge]: 'რუბლებში',
    },
    allPatientsProgram: {
        [Locale.Ru]: 'Все программы пациента',
        [Locale.Am]: 'Պացիենտի բոլոր ծրագրերը',
        [Locale.En]: 'All patient programs',
        [Locale.Pt]: 'Todos os programas do paciente',
        [Locale.Ge]: 'ყველა პაციენტის პროგრამა',
    },
    discounts: {
        [Locale.Ru]: 'Скидки',
        [Locale.Am]: 'Զեղչեր',
        [Locale.En]: 'Discounts',
        [Locale.Pt]: 'Descontos',
        [Locale.Ge]: 'ფასდაკლება',
    },
    discount: {
        [Locale.Ru]: 'Скидка',
        [Locale.Am]: 'Զեղչ',
        [Locale.En]: 'Discount',
        [Locale.Pt]: 'Desconto',
        [Locale.Ge]: 'ფასდაკლება',
    },
    createDiscount: {
        [Locale.Ru]: 'Создать скидку',
        [Locale.Am]: 'Ստեղծել զեղչ',
        [Locale.En]: 'Create discount',
        [Locale.Pt]: 'Criar desconto',
        [Locale.Ge]: 'შექმნა ფასდაკლება',
    },
    editDiscount: {
        [Locale.Ru]: 'Редактировать скидку',
        [Locale.Am]: 'Խմբագրել զեղչը',
        [Locale.En]: 'Edit discount',
        [Locale.Pt]: 'Editar desconto',
        [Locale.Ge]: 'შეცვლა ფასდაკლება',
    },
    legalEntityDoesNotBelongToContract: {
        [Locale.Ru]: 'Юрлицо не относится к выбранному договору',
        [Locale.Am]: 'Իրավաբանական անձը չի պատկանում ընտրված պայմանագրին',
        [Locale.En]: 'The legal entity does not belong to the selected contract',
        [Locale.Pt]: 'A pessoa jurídica não pertence ao contrato selecionado',
        [Locale.Ge]: 'იურიდიული პირი არ ეკუთვნის არჩეულ ხელშეკრულებას',
    },
    flatDiscountRequired: {
        [Locale.Ru]: 'Укажите размер фиксированной скидки',
        [Locale.Am]: 'Նշեք ֆիքսված զեղչի չափը',
        [Locale.En]: 'Specify the flat discount amount',
        [Locale.Pt]: 'Informe o valor do desconto fixo',
        [Locale.Ge]: 'მიუთითეთ ფიქსირებული ფასდაკლების ოდენობა',
    },
    averageDiscountRequired: {
        [Locale.Ru]: 'Укажите размер средней скидки',
        [Locale.Am]: 'Նշեք միջին զեղչի չափը',
        [Locale.En]: 'Specify the average discount amount',
        [Locale.Pt]: 'Informe o valor do desconto médio',
        [Locale.Ge]: 'მიუთითეთ საშუალო ფასდაკლების ოდენობა',
    },
    hurdleDiscountRequired: {
        [Locale.Ru]: 'Добавьте хотя бы один порог',
        [Locale.Am]: 'Ավելացրեք առնվազն մեկ շեմ',
        [Locale.En]: 'Add at least one threshold',
        [Locale.Pt]: 'Adicione pelo menos um patamar',
        [Locale.Ge]: 'დაამატეთ მინიმუმ ერთი ზღვარი',
    },
    invalidFlatDiscount: {
        [Locale.Ru]: 'Фиксированная скидка должна быть от 0 до 100',
        [Locale.Am]: 'Ֆիքսված զեղչը պետք է լինի 0-ից 100',
        [Locale.En]: 'The flat discount must be between 0 and 100',
        [Locale.Pt]: 'O desconto fixo deve estar entre 0 e 100',
        [Locale.Ge]: 'ფიქსირებული ფასდაკლება უნდა იყოს 0-დან 100-მდე',
    },
    invalidAverageDiscount: {
        [Locale.Ru]: 'Средняя скидка должна быть целым числом от 0 до 100',
        [Locale.Am]: 'Միջին զեղչը պետք է լինի ամբողջ թիվ 0-ից 100',
        [Locale.En]: 'The average discount must be a whole number between 0 and 100',
        [Locale.Pt]: 'O desconto médio deve ser um número inteiro entre 0 e 100',
        [Locale.Ge]: 'საშუალო ფასდაკლება უნდა იყოს მთელი რიცხვი 0-დან 100-მდე',
    },
    invalidHurdle: {
        [Locale.Ru]: 'Порог должен быть целым числом больше 0',
        [Locale.Am]: 'Շեմը պետք է լինի 0-ից մեծ ամբողջ թիվ',
        [Locale.En]: 'The threshold must be a whole number greater than 0',
        [Locale.Pt]: 'O patamar deve ser um número inteiro maior que 0',
        [Locale.Ge]: 'ზღვარი უნდა იყოს 0-ზე მეტი მთელი რიცხვი',
    },
    invalidHurdleRate: {
        [Locale.Ru]: 'Ставка должна быть от 0 до 1, не более двух знаков после запятой',
        [Locale.Am]: 'Դրույքը պետք է լինի 0-ից 1, ստորակետից հետո ոչ ավելի քան երկու նիշ',
        [Locale.En]: 'The rate must be between 0 and 1 with at most two decimal places',
        [Locale.Pt]: 'A taxa deve estar entre 0 e 1, com no máximo duas casas decimais',
        [Locale.Ge]: 'განაკვეთი უნდა იყოს 0-დან 1-მდე, მძიმის შემდეგ არაუმეტეს ორი ციფრით',
    },
    includedAndExcludedCategoriesConflict: {
        [Locale.Ru]: 'Можно выбрать либо включённые, либо исключённые категории, но не оба списка сразу',
        [Locale.Am]: 'Կարելի է ընտրել կամ ներառված, կամ բացառված կատեգորիաներ, բայց ոչ երկուսը միաժամանակ',
        [Locale.En]: 'Select either included or excluded categories, not both',
        [Locale.Pt]: 'Selecione categorias incluídas ou excluídas, não ambas',
        [Locale.Ge]: 'აირჩიეთ ან ჩართული, ან გამორიცხული კატეგორიები, არა ორივე ერთად',
    },
    archiveDateBeforeActivationDate: {
        [Locale.Ru]: 'Дата архивации не может быть раньше даты активации',
        [Locale.Am]: 'Արխիվացման ամսաթիվը չի կարող լինել ակտիվացման ամսաթվից շուտ',
        [Locale.En]: 'The archive date cannot be earlier than the activation date',
        [Locale.Pt]: 'A data de arquivamento não pode ser anterior à data de ativação',
        [Locale.Ge]: 'არქივირების თარიღი არ შეიძლება იყოს აქტივაციის თარიღზე ადრე',
    },
    discountNotFound: {
        [Locale.Ru]: 'Скидка не найдена — возможно, её уже удалили',
        [Locale.Am]: 'Զեղչը չի գտնվել. հնարավոր է՝ այն արդեն ջնջվել է',
        [Locale.En]: 'Discount not found: it may have already been deleted',
        [Locale.Pt]: 'Desconto não encontrado: talvez já tenha sido excluído',
        [Locale.Ge]: 'ფასდაკლება ვერ მოიძებნა — შესაძლოა, უკვე წაიშალა',
    },
    discountAlreadyExists: {
        [Locale.Ru]: 'Скидка с такими категориями на этот период уже существует',
        [Locale.Am]: 'Այս կատեգորիաներով զեղչ այս ժամանակահատվածի համար արդեն գոյություն ունի',
        [Locale.En]: 'A discount with these categories already exists for this period',
        [Locale.Pt]: 'Já existe um desconto com estas categorias para este período',
        [Locale.Ge]: 'ამ კატეგორიებით ფასდაკლება ამ პერიოდისთვის უკვე არსებობს',
    },
    includedCategories: {
        [Locale.Ru]: 'Включенные категории',
        [Locale.Am]: 'Ներառված կատեգորիաներ',
        [Locale.En]: 'Included categories',
        [Locale.Pt]: 'Categorias incluídas',
        [Locale.Ge]: 'შემდგომი კატეგორიები',
    },
    excludedCategories: {
        [Locale.Ru]: 'Исключенные категории',
        [Locale.Am]: 'Բացառված կատեգորիաներ',
        [Locale.En]: 'Excluded categories',
        [Locale.Pt]: 'Categorias excluídas',
        [Locale.Ge]: 'გამორჩეული კატეგორიები',
    },
    newReferral: {
        [Locale.Ru]: 'Новое направление',
        [Locale.Am]: 'Նոր ուղեգիր',
        [Locale.En]: 'New Referral',
        [Locale.Pt]: 'Novo Encaminhamento',
        [Locale.Ge]: 'ახალი მიმართულება',
    },
    youMostOftenAssign: {
        [Locale.Ru]: 'Вы чаще всего назначаете',
        [Locale.Am]: 'Դուք ամենից հաճախ նշանակում եք',
        [Locale.En]: 'You most often assign',
        [Locale.Pt]: 'Você atribui com mais frequência',
        [Locale.Ge]: 'თქვენ ყველაზე ხშირად მიანიჭებთ',
    },
    defaultExpirationDate: {
        [Locale.Ru]: 'Срок действия по умолчанию',
        [Locale.Am]: 'Լռելյայն գործողության ժամկետ',
        [Locale.En]: 'Default expiration date',
        [Locale.Pt]: 'Data de expiração padrão',
        [Locale.Ge]: 'ნაგულისხმევი ვადის გასვლის თარიღი',
    },
    defaultOptions: {
        [Locale.Ru]: 'Настройки по-умолчанию',
        [Locale.Am]: 'Լռելյայն կարգավորումներ',
        [Locale.En]: 'Default settings',
        [Locale.Pt]: 'Configurações padrão',
        [Locale.Ge]: 'ნაგულისხმევი პარამეტები',
    },
    toChangeThemClickOnTheDirectionName: {
        [Locale.Ru]: 'Чтобы изменить их, кликните на название направления',
        [Locale.Am]: 'Դրանք փոփոխելու համար սեղմեք ուղեգրի անվանման վրա',
        [Locale.En]: 'To change them, click on the direction name',
        [Locale.Pt]: 'Para alterá-las, clique no nome do encaminhamento',
        [Locale.Ge]: 'რომელიმე შეცვლით, დააკლიკეთ რეფერალის დასახელებას',
    },
    defaultExpirationDatePartTwo: {
        [Locale.Ru]: 'дней, начиная с сегодня',
        [Locale.Am]: 'օր՝ սկսած այսօրվանից',
        [Locale.En]: 'days starting from today',
        [Locale.Pt]: 'dias a partir de hoje',
        [Locale.Ge]: 'დღეიდან დაწყებული დღეები',
    },
    whoIssuedReferral: {
        [Locale.Ru]: 'Кто выдал направление',
        [Locale.Am]: 'Ով է տվել ուղեգիրը',
        [Locale.En]: 'Who gave the direction',
        [Locale.Pt]: 'Quem emitiu o encaminhamento',
        [Locale.Ge]: 'ვინ გასცა რეფერალი',
    },
    changeDefaultSettings: {
        [Locale.Ru]: 'Чтобы изменить настройки по умолчанию, кликните на название направления',
        [Locale.Am]: 'Լռելյայն կարգավորումները փոփոխելու համար սեղմեք ուղեգրի անվանման վրա',
        [Locale.En]: 'To change the default settings, click on the direction name',
        [Locale.Pt]: 'Para alterar as configurações padrão, clique no nome do encaminhamento',
        [Locale.Ge]: 'ნაგულისხმევი პარამეტრების შესაცვლელად, დააჭირეთ მიმართულების სახელს',
    },
    externalReferral: {
        [Locale.Ru]: 'Внешнее направление',
        [Locale.Am]: 'Արտաքին ուղեգիր',
        [Locale.En]: 'External referral',
        [Locale.Pt]: 'Encaminhamento externo',
        [Locale.Ge]: 'გარე მიმართულება',
    },
    useThisDirectionForServicesOrDoctors: {
        [Locale.Ru]: 'Используйте это направление для услуг или докторов, которых нет в Чайке. А также для планирования комплексных этапов лечения',
        [Locale.Am]: 'Օգտագործեք այս ուղեգիրը այն ծառայությունների կամ բժիշկների համար, որոնք չկան Չայկայում։ Ինչպես նաև բուժման համալիր փուլերի պլանավորման համար',
        [Locale.En]: 'Use this referral for services or doctors that are not in the Seagull. And also for planning complex stages of treatment',
        [Locale.Pt]: 'Use este encaminhamento para serviços ou médicos que não estão no sistema. E também para planejar etapas complexas de tratamento',
        [Locale.Ge]: 'გამოიყენეთ ეს მიმართულება იმ სერვისებისთვის ან ექიმებისთვის, რომლებიც ჩაიკაში არ არიან. და ასევე მკურნალობის რთული ეტაპების დაგეგმვისთვის',
    },
    createReferral: {
        [Locale.Ru]: 'Создать направление',
        [Locale.Am]: 'Ստեղծել ուղեգիր',
        [Locale.En]: 'Create referral',
        [Locale.Pt]: 'Criar encaminhamento',
        [Locale.Ge]: 'შექმენით მიმართულება',
    },
    errorReferralCreation: {
        [Locale.Ru]: 'Возникла ошибка при создании направления',
        [Locale.Am]: 'Ուղեգիր ստեղծելիս առաջացել է սխալ',
        [Locale.En]: 'An error occurred while creating the direction',
        [Locale.Pt]: 'Ocorreu um erro ao criar o encaminhamento',
        [Locale.Ge]: 'შეცდომა მოხდა მიმართულების შექმნისას',
    },
    addReferral: {
        [Locale.Ru]: 'Добавление направления',
        [Locale.Am]: 'Ուղեգրի ավելացում',
        [Locale.En]: 'Adding direction',
        [Locale.Pt]: 'Adicionar encaminhamento',
        [Locale.Ge]: 'მიმართულების დამატება',
    },
    addReferralDescription: {
        [Locale.Ru]: 'Для того, чтобы добавить направление, необходимо выбрать направившего доктора',
        [Locale.Am]: 'Ուղեգիր ավելացնելու համար անհրաժեշտ է ընտրել ուղեգրող բժշկին',
        [Locale.En]: 'In order to add a referral, you must select the referring doctor',
        [Locale.Pt]: 'Para adicionar um encaminhamento, você deve selecionar o médico solicitante',
        [Locale.Ge]: 'იმისათვის, რომ დაამატოთ რეფერალური, თქვენ უნდა აირჩიოთ გულისხმობდა ექიმი',
    },
    activeReferrals: {
        [Locale.Ru]: 'Активные направления',
        [Locale.Am]: 'Ակտիվ ուղեգրեր',
        [Locale.En]: 'Active referrals',
        [Locale.Pt]: 'Encaminhamentos ativos',
        [Locale.Ge]: 'აქტიური მიმართულება',
    },
    issuedEarlier: {
        [Locale.Ru]: 'Выданные ранее',
        [Locale.Am]: 'Նախկինում տրվածներ',
        [Locale.En]: 'Issued earlier',
        [Locale.Pt]: 'Emitido anteriormente',
        [Locale.Ge]: 'გამოსანაცვლებული',
    },
    hasActiveReferral: {
        [Locale.Ru]: 'Есть активное направление',
        [Locale.Am]: 'Կա ակտիվ ուղեգիր',
        [Locale.En]: 'There is an active direction',
        [Locale.Pt]: 'Existe um encaminhamento ativo',
        [Locale.Ge]: 'არსებობს აქტიური მიმართულება',
    },
    hasActiveReferralForCurrentService: {
        [Locale.Ru]: 'Есть активное направление для данной услуги. Создать еще одно направление?',
        [Locale.Am]: 'Այս ծառայության համար կա ակտիվ ուղեգիր։ Ստեղծե՞լ ևս մեկ ուղեգիր',
        [Locale.En]: 'There is an active direction for this service. Create another direction?',
        [Locale.Pt]: 'Existe um encaminhamento ativo para este serviço. Criar outro encaminhamento?',
        [Locale.Ge]: 'ამ სერვისისთვის აქტიური მიმართულებაა. შექმენით სხვა მიმართულება?',
    },
    treatmentPlanHasThisReferral: {
        [Locale.Ru]: 'Такое направление уже есть в этом плане лечения.\n Создать новое?',
        [Locale.Am]: 'Այսպիսի ուղեգիր արդեն կա այս բուժման պլանում։\n Ստեղծե՞լ նորը',
        [Locale.En]: 'There is already such a direction in this treatment plan.\n Create a new one?',
        [Locale.Pt]: 'Já existe tal encaminhamento neste plano de tratamento.\n Criar um novo?',
        [Locale.Ge]: 'ამ მკურნალობის გეგმაში უკვე არსებობს ასეთი მიმართულება.\n შექმენით ახალი?',
    },
    treatmentPlanHasThisReferralAddToCase: {
        [Locale.Ru]: 'Такое направление уже есть в плане лечения пациента по эпизоду',
        [Locale.Am]: 'Այսպիսի ուղեգիր արդեն կա պացիենտի բուժման պլանում ըստ էպիզոդի',
        [Locale.En]: `There is already such a direction in the patient's episode treatment plan`,
        [Locale.Pt]: 'Já existe tal encaminhamento no plano de tratamento do episódio do paciente',
        [Locale.Ge]: 'უკვე არსებობს ასეთი მიმართულება პაციენტის მკურნალობის გეგმაში ეპიზოდისთვის',
    },
    treatmentPlanHasThisReferralAddToCasePartTwo: {
        [Locale.Ru]: 'Добавить его в ваш эпизод?',
        [Locale.Am]: 'Ավելացնե՞լ այն ձեր էպիզոդում',
        [Locale.En]: 'Add it to your episode?',
        [Locale.Pt]: 'Adicioná-lo ao seu episódio?',
        [Locale.Ge]: 'დაამატეთ იგი თქვენს ეპიზოდს?',
    },
    serviceNameNotFound: {
        [Locale.Ru]: 'Название услуги не найдено',
        [Locale.Am]: 'Ծառայության անվանումը չի գտնվել',
        [Locale.En]: 'Service name not found',
        [Locale.Pt]: 'Nome do serviço não encontrado',
        [Locale.Ge]: 'სამსახურის სახელი ვერ მოიძებნა',
    },
    createNewGroup: {
        [Locale.Ru]: 'Создать новую группу',
        [Locale.Am]: 'Ստեղծել նոր խումբ',
        [Locale.En]: 'Create a new group',
        [Locale.Pt]: 'Criar um novo grupo',
        [Locale.Ge]: 'შექმენით ახალი ჯგუფი',
    },
    addGroupToPlan: {
        [Locale.Ru]: 'Добавить группу в план',
        [Locale.Am]: 'Ավելացնել խումբը պլանում',
        [Locale.En]: 'Add a group to the plan',
        [Locale.Pt]: 'Adicionar um grupo ao plano',
        [Locale.Ge]: 'დაამატეთ ჯგუფი გეგმაში',
    },
    hasArchivedReferrals: {
        [Locale.Ru]: 'Есть архивные',
        [Locale.Am]: 'Կան արխիվայիններ',
        [Locale.En]: 'With archived',
        [Locale.Pt]: 'Com ficheiros',
        [Locale.Ge]: 'With archived',
    },
    addNewFavoriteFolder: {
        [Locale.Ru]: 'Добавить новую папку избранного',
        [Locale.Am]: 'Ավելացնել ընտրյալների նոր պանակ',
        [Locale.En]: 'Add new favorites folder',
        [Locale.Pt]: 'Adicionar nova pasta de favoritos',
        [Locale.Ge]: 'დაამატეთ ახალი ფავორიტების საქაღალდე',
    },
    addNew: {
        [Locale.Ru]: 'Добавить новую',
        [Locale.Am]: 'Ավելացնել նորը',
        [Locale.En]: 'Add new',
        [Locale.Pt]: 'Adicionar novo',
        [Locale.Ge]: 'Add new',
    },
    laboratoryData: {
        [Locale.Ru]: 'Данные по лаборатории',
        [Locale.Am]: 'Լաբորատորիայի տվյալներ',
        [Locale.En]: 'Laboratory data',
        [Locale.Pt]: 'Dados laboratoriais',
        [Locale.Ge]: 'ლაბორატორიული მონაცემები',
    },
    indefinite: {
        [Locale.Ru]: 'Бессрочное',
        [Locale.Am]: 'Անժամկետ',
        [Locale.En]: 'Indefinite',
        [Locale.Pt]: 'Indefinido',
        [Locale.Ge]: 'განუსაზღვრელი',
    },
    indefiniteFem: {
        [Locale.Ru]: 'Бессрочная',
        [Locale.Am]: 'Անժամկետ',
        [Locale.En]: 'Indefinite',
        [Locale.Pt]: 'Indefinida',
        [Locale.Ge]: 'განუსაზღვრელი',
    },
    whoSent: {
        [Locale.Ru]: 'Кто направил',
        [Locale.Am]: 'Ով է ուղեգրել',
        [Locale.En]: 'Who directed',
        [Locale.Pt]: 'Quem dirigiu',
        [Locale.Ge]: 'ვინ ხელმძღვანელობდა',
    },
    directed: {
        [Locale.Ru]: 'Направил',
        [Locale.Am]: 'Ուղեգրել է',
        [Locale.En]: 'Directed',
        [Locale.Pt]: 'Endereçado',
        [Locale.Ge]: 'ხელმძღვანელობდა',
    },
    lookSchedule: {
        [Locale.Ru]: 'Посмотреть расписание',
        [Locale.Am]: 'Դիտել ժամանակացույցը',
        [Locale.En]: 'View the schedule',
        [Locale.Pt]: 'Veja a programação',
        [Locale.Ge]: 'გრაფიკის ნახვა',
    },
    deleteFromCase: {
        [Locale.Ru]: 'Убрать из эпизода',
        [Locale.Am]: 'Հեռացնել էպիզոդից',
        [Locale.En]: 'Remove from the episode',
        [Locale.Pt]: 'Remover do episódio',
        [Locale.Ge]: 'ეპიზოდიდან ამოღება',
    },
    deleteReferral: {
        [Locale.Ru]: 'Удалить направление',
        [Locale.Am]: 'Ջնջել ուղեգիրը',
        [Locale.En]: 'Delete direction',
        [Locale.Pt]: 'Excluir encaminhamento',
        [Locale.Ge]: 'წაშლა მიმართულებით',
    },
    editLabData: {
        [Locale.Ru]: 'Редактировать данные по лаборатории',
        [Locale.Am]: 'Խմբագրել լաբորատորիայի տվյալները',
        [Locale.En]: 'Edit lab data',
        [Locale.Pt]: 'Editar dados de laboratório',
        [Locale.Ge]: 'რედაქტირება ლაბორატორიული მონაცემები',
    },
    courseService: {
        [Locale.Ru]: 'Курсовая услуга, необходимо указать количество',
        [Locale.Am]: 'Կուրսային ծառայություն, անհրաժեշտ է նշել քանակը',
        [Locale.En]: 'Course service, quantity must be specified',
        [Locale.Pt]: 'Serviço do curso, quantidade deve ser especificada',
        [Locale.Ge]: 'რა თქმა უნდა, მომსახურება, აუცილებელია მიუთითოთ რაოდენობ',
    },
    urgentReferral: {
        [Locale.Ru]: 'Срочное направление',
        [Locale.Am]: 'Հրատապ ուղեգիր',
        [Locale.En]: 'Urgent referral',
        [Locale.Pt]: 'Encaminhamento urgente',
        [Locale.Ge]: 'გადაუდებელი რეფერალი',
    },
    urgent: {
        [Locale.Ru]: 'Срочное',
        [Locale.Am]: 'Հրատապ',
        [Locale.En]: 'Urgent',
        [Locale.Pt]: 'Urgente',
        [Locale.Ge]: 'გადაუდებელი',
    },
    urgentSecond: {
        [Locale.Ru]: 'Срочно',
        [Locale.Am]: 'Հրատապ',
        [Locale.En]: 'Urgent',
        [Locale.Pt]: 'Urgente',
        [Locale.Ge]: 'გადაუდებელი',
    },
    compositionServices: {
        [Locale.Ru]: 'Состав услуг',
        [Locale.Am]: 'Ծառայությունների կազմ',
        [Locale.En]: 'Composition of services',
        [Locale.Pt]: 'Composição dos serviços',
        [Locale.Ge]: 'მომსახურების შემადგენლობა',
    },
    commentToReferral: {
        [Locale.Ru]: 'Комментарий к направлению',
        [Locale.Am]: 'Մեկնաբանություն ուղեգրի վերաբերյալ',
        [Locale.En]: 'Comment on the direction',
        [Locale.Pt]: 'Comente sobre a direção',
        [Locale.Ge]: 'კომენტარი მიმართულებით',
    },
    notNecessarily: {
        [Locale.Ru]: 'Не обязательно',
        [Locale.Am]: 'Պարտադիր չէ',
        [Locale.En]: 'Not necessarily',
        [Locale.Pt]: 'Não necessariamente',
        [Locale.Ge]: 'არ არის აუცილებელი',
    },
    costService: {
        [Locale.Ru]: 'Стоимость услуги',
        [Locale.Am]: 'Ծառայության արժեք',
        [Locale.En]: 'The cost of the service',
        [Locale.Pt]: 'O custo do serviço',
        [Locale.Ge]: 'მომსახურების ღირებულება',
    },
    costPrice: {
        [Locale.Ru]: 'Себестоимость',
        [Locale.Am]: 'Ինքնարժեք',
        [Locale.En]: 'Cost Price',
        [Locale.Pt]: 'Preço de custo',
        [Locale.Ge]: 'ღირებულება ფასი',
    },
    directionConnectedToOtherCases: {
        [Locale.Ru]: 'Направление связано к другими эпизодам. Чтобы удалить его, обратитесь в IT Helpdesk',
        [Locale.Am]: 'Ուղեգիրը կապված է այլ էպիզոդների հետ։ Այն ջնջելու համար դիմեք IT Helpdesk',
        [Locale.En]: 'The direction is related to other episodes. To remove it, contact IT Helpdesk',
        [Locale.Pt]: 'A direção está relacionada a outros episódios. Para removê-lo, entre em contato com o Helpdesk de TI',
        [Locale.Ge]: 'რეჟისორობა დაკავშირებულია სხვა ეპიზოდებთან. ამოიღონ იგი, დაუკავშირდით მას Helpdesk',
    },
    welcomeMessage: {
        [Locale.Ru]: 'Приветственное сообщение',
        [Locale.Am]: 'Ողջույնի հաղորդագրություն',
        [Locale.En]: 'Welcome message',
        [Locale.Pt]: 'Mensagem de boas-vindas',
        [Locale.Ge]: 'მისასალმებელი შეტყობინება',
    },
    createAstraShareLink: {
        [Locale.Ru]: 'Создать ссылку в AstraShare',
        [Locale.Am]: 'Ստեղծել հղում AstraShare-ում',
        [Locale.En]: 'Create AstraShare link',
        [Locale.Pt]: 'Criar link AstraShare',
        [Locale.Ge]: 'შექმენით ბმული AstraShare-ში',
    },
    sendTask: {
        [Locale.Ru]: 'Отправить задание',
        [Locale.Am]: 'Ուղարկել առաջադրանք',
        [Locale.En]: 'Send task',
        [Locale.Pt]: 'Enviar tarefa',
        [Locale.Ge]: 'გაგზავნით დამატებული დამატება',
    },
    sendDeviceTask: {
        [Locale.Ru]: 'Отправить задание на прибор',
        [Locale.Am]: 'Ուղարկել առաջադրանք սարքին',
        [Locale.En]: 'Send a task to the device',
        [Locale.Pt]: 'Envie uma tarefa para o dispositivo',
        [Locale.Ge]: 'გაგზავნით დამატებული დეველის დამატება',
    },
    chooseDeviceForResearch: {
        [Locale.Ru]: 'Выберите прибор для проведения исследования',
        [Locale.Am]: 'Ընտրեք սարքը հետազոտություն անցկացնելու համար',
        [Locale.En]: 'Choose a device for research',
        [Locale.Pt]: 'Procurar',
        [Locale.Ge]: 'აირჩიე დეველი დამატებული დამატება',
    },
    repliedEntry: {
        [Locale.Ru]: 'Ответная запись',
        [Locale.Am]: 'Պատասխան գրառում',
        [Locale.En]: 'Replied entry',
        [Locale.Pt]: 'Entrada respondida',
        [Locale.Ge]: 'პასუხის ჩანაწერი',
    },
    createdReplyEntry: {
        [Locale.Ru]: 'Создана ответная запись',
        [Locale.Am]: 'Ստեղծվել է պատասխան գրառում',
        [Locale.En]: 'Created reply entry',
        [Locale.Pt]: 'Entrada de resposta criada',
        [Locale.Ge]: 'შეიქმნა საპასუხო ჩანაწერი',
    },
    newDrug: {
        [Locale.Ru]: 'Новый медикамент',
        [Locale.Am]: 'Նոր դեղամիջոց',
        [Locale.En]: 'New Drug',
        [Locale.Pt]: 'Nova droga',
        [Locale.Ge]: 'ახალი მედიცინა',
    },
    activeSubstance: {
        [Locale.Ru]: 'Действующее вещество',
        [Locale.Am]: 'Ակտիվ նյութ',
        [Locale.En]: 'Active substance',
        [Locale.Pt]: 'Substância ativa',
        [Locale.Ge]: 'აქტიური ნივთიერება',
    },
    tradeName: {
        [Locale.Ru]: 'Торговое название',
        [Locale.Am]: 'Առևտրային անվանում',
        [Locale.En]: 'Trade name',
        [Locale.Pt]: 'Nome comercial',
        [Locale.Ge]: 'სავაჭრო სახელი',
    },
    newDrugFromFavorite: {
        [Locale.Ru]: 'Новый медикамент в избранном',
        [Locale.Am]: 'Նոր դեղամիջոց ընտրյալներում',
        [Locale.En]: 'New drug from favorites',
        [Locale.Pt]: 'Novo medicamento dos favoritos',
        [Locale.Ge]: 'ახალი მედიცინა ფავორიტებში',
    },
    editDrug: {
        [Locale.Ru]: 'Редактировать медикамент',
        [Locale.Am]: 'Խմբագրել դեղամիջոցը',
        [Locale.En]: 'Edit drug',
        [Locale.Pt]: 'Editar droga',
        [Locale.Ge]: 'რედაქტირება წამალი',
    },
    instructionsForReception: {
        [Locale.Ru]: 'Указания по приему',
        [Locale.Am]: 'Ընդունման ցուցումներ',
        [Locale.En]: 'Instructions for reception',
        [Locale.Pt]: 'Instruções para recepção',
        [Locale.Ge]: 'მიღების ინსტრუქცია',
    },
    stopReceiving: {
        [Locale.Ru]: 'Прекратить приём',
        [Locale.Am]: 'Դադարեցնել ընդունումը',
        [Locale.En]: 'Stop receiving',
        [Locale.Pt]: 'Pare de receber',
        [Locale.Ge]: 'შეწყვიტე მიღება',
    },
    addToFavorite: {
        [Locale.Ru]: 'Добавить в избранное',
        [Locale.Am]: 'Ավելացնել ընտրյալներում',
        [Locale.En]: 'Add to favorite',
        [Locale.Pt]: 'Adicionar aos favoritos',
        [Locale.Ge]: 'რჩეულებში საყვარელი',
    },
    prescribedDrug: {
        [Locale.Ru]: 'Назначенный медикамент',
        [Locale.Am]: 'Նշանակված դեղամիջոց',
        [Locale.En]: 'Prescribed drug',
        [Locale.Pt]: 'Medicamento prescrito',
        [Locale.Ge]: 'დადგენილი წამალი',
    },
    whoPrescribed: {
        [Locale.Ru]: 'Кто назначил',
        [Locale.Am]: 'Ով է նշանակել',
        [Locale.En]: 'Who prescribed',
        [Locale.Pt]: 'Quem prescreveu',
        [Locale.Ge]: 'Who prescribed',
    },
    whoAddedEntry: {
        [Locale.Ru]: 'Кто внес запись',
        [Locale.Am]: 'Ով է կատարել գրառումը',
        [Locale.En]: 'Who added entry',
        [Locale.Pt]: 'Quem adicionou a entrada',
        [Locale.Ge]: 'Who added entry',
    },
    frequencyReception: {
        [Locale.Ru]: 'Кратность приема',
        [Locale.Am]: 'Ընդունման հաճախականություն',
        [Locale.En]: 'Frequency reception',
        [Locale.Pt]: 'Recepção de frequência',
        [Locale.Ge]: 'მიღების სიმრავლე',
    },
    favoriteDrugDescription: {
        [Locale.Ru]: 'Создавайте шаблоны медикаментов, чтобы быстрее делать назначения в следующий раз. При добавлении в план лечения медикамент будет назначаться с сегодняшнего дня.',
        [Locale.Am]: 'Ստեղծեք դեղամիջոցների ձևանմուշներ՝ հաջորդ անգամ ավելի արագ նշանակումներ անելու համար։ Բուժման պլանում ավելացնելիս դեղամիջոցը կնշանակվի այսօրվանից։',
        [Locale.En]: 'Create drug templates to make prescriptions faster next time. When added to the treatment plan, the drug will be prescribed from today.',
        [Locale.Pt]: 'Crie modelos de medicamentos para tornar as prescrições mais rápidas na próxima vez. Quando adicionado ao plano de tratamento, o medicamento será prescrito a partir de hoje.',
        [Locale.Ge]: 'შექმნა მედიკამენტების თარგები, რათა დანიშნულება სწრაფად მომავალი დრო. მკურნალობის გეგმას რომ დაემატება, წამალი დღეიდან დაინიშნება.',
    },
    addNewDrug: {
        [Locale.Ru]: 'Добавить новый медикамент',
        [Locale.Am]: 'Ավելացնել նոր դեղամիջոց',
        [Locale.En]: 'Add new drug',
        [Locale.Pt]: 'Adicionar novo medicamento',
        [Locale.Ge]: 'დაამატეთ ახალი წამალი',
    },
    searchDrugsAndGroups: {
        [Locale.Ru]: 'Поиск по медикаментам и группам',
        [Locale.Am]: 'Որոնում ըստ դեղամիջոցների և խմբերի',
        [Locale.En]: 'Search drugs and groups',
        [Locale.Pt]: 'Pesquisar medicamentos e grupos',
        [Locale.Ge]: 'მედიკამენტებისა და ჯგუფების ძიება',
    },
    addChosen: {
        [Locale.Ru]: 'Добавить выбранные',
        [Locale.Am]: 'Ավելացնել ընտրվածները',
        [Locale.En]: 'Add chosen',
        [Locale.Pt]: 'Adicionar escolhido',
        [Locale.Ge]: 'რჩეულებში შერჩეული',
    },
    deleteDrug: {
        [Locale.Ru]: 'Удалить медикамент',
        [Locale.Am]: 'Ջնջել դեղամիջոցը',
        [Locale.En]: 'Delete drug',
        [Locale.Pt]: 'Excluir medicamento',
        [Locale.Ge]: 'მედიკამენტების ამოღება',
    },
    changeFromGroups: {
        [Locale.Ru]: 'Изменить в группах',
        [Locale.Am]: 'Փոփոխել խմբերում',
        [Locale.En]: 'Change from groups',
        [Locale.Pt]: 'Mudar de grupos',
        [Locale.Ge]: 'რედაქტირება ჯგუფებში',
    },
    favoriteGroup: {
        [Locale.Ru]: 'Группа избранного',
        [Locale.Am]: 'Ընտրյալների խումբ',
        [Locale.En]: 'Favorite group',
        [Locale.Pt]: 'Grupo favorito',
        [Locale.Ge]: 'ფავორიტების ჯგუფი',
    },
    errorDrugCreation: {
        [Locale.Ru]: 'Возникла ошибка при создании медикамента',
        [Locale.Am]: 'Դեղամիջոց ստեղծելիս առաջացել է սխալ',
        [Locale.En]: 'An error occurred while creating drug',
        [Locale.Pt]: 'Ocorreu um erro ao criar o medicamento',
        [Locale.Ge]: 'შეცდომა მოხდა მედიკამენტის შექმნისას',
    },
    acceptancePeriod: {
        [Locale.Ru]: 'Срок приема',
        [Locale.Am]: 'Ընդունման ժամկետ',
        [Locale.En]: 'Acceptance period',
        [Locale.Pt]: 'Período de aceitação',
        [Locale.Ge]: 'მიღების პერიოდი',
    },
    taskCompleted: {
        [Locale.Ru]: 'Задание выполнено',
        [Locale.Am]: 'Առաջադրանքը կատարված է',
        [Locale.En]: 'Task completed',
        [Locale.Pt]: 'Tarefa concluída',
        [Locale.Ge]: 'დავალება შესრულებულია',
    },
    returnToUnfulfilled: {
        [Locale.Ru]: 'Вернуть в невыполненные',
        [Locale.Am]: 'Վերադարձնել չկատարվածների մեջ',
        [Locale.En]: 'Return to unfulfilled',
        [Locale.Pt]: 'Devolver para não concluídas',
        [Locale.Ge]: 'დაუსრულებლებში დაბრუნება',
    },
    taskEditing: {
        [Locale.Ru]: 'Редактирование задания',
        [Locale.Am]: 'Առաջադրանքի խմբագրում',
        [Locale.En]: 'Task editing',
        [Locale.Pt]: 'Edição da tarefa',
        [Locale.Ge]: 'დავალების რედაქტირება',
    },
    newTask: {
        [Locale.Ru]: 'Новое задание',
        [Locale.Am]: 'Նոր առաջադրանք',
        [Locale.En]: 'New task',
        [Locale.Pt]: 'Nova tarefa',
        [Locale.Ge]: 'ახალი ამოცანა',
    },
    actualPerformer: {
        [Locale.Ru]: 'Фактический исполнитель',
        [Locale.Am]: 'Փաստացի կատարող',
        [Locale.En]: 'Actual Performer',
        [Locale.Pt]: 'Artista real',
        [Locale.Ge]: 'ფაქტობრივი შემსრულებელი',
    },
    executorOnlyMe: {
        [Locale.Ru]: 'Назначить только меня',
        [Locale.Am]: 'Նշանակել միայն ինձ',
        [Locale.En]: 'Assign only me',
        [Locale.Pt]: 'Atribuir apenas a mim',
        [Locale.Ge]: 'მივანიჭოთ მხოლოდ მე',
    },
    whatNeedsToBeDone: {
        [Locale.Ru]: 'Что нужно сделать',
        [Locale.Am]: 'Ինչ է անհրաժեշտ անել',
        [Locale.En]: 'What needs to be done',
        [Locale.Pt]: 'O que precisa ser feito',
        [Locale.Ge]: 'რა უნდა გაკეთდეს',
    },
    describeClearly: {
        [Locale.Ru]: 'Описывайте ясно и по-возможности кратко',
        [Locale.Am]: 'Նկարագրեք հստակ և հնարավորինս հակիրճ',
        [Locale.En]: 'Describe clearly and as briefly as possible',
        [Locale.Pt]: 'Descreva com clareza e o mais brevemente possível',
        [Locale.Ge]: 'აღწერეთ ნათლად და რაც შეიძლება მოკლედ',
    },
    taskDescription: {
        [Locale.Ru]: 'Пояснение к заданию',
        [Locale.Am]: 'Բացատրություն առաջադրանքի վերաբերյալ',
        [Locale.En]: 'Explanation of the task',
        [Locale.Pt]: 'Explicação da tarefa',
        [Locale.Ge]: 'ამოცანის ახსნა',
    },
    taskSent: {
        [Locale.Ru]: 'Задание отправлено',
        [Locale.Am]: 'Առաջադրանքն ուղարկված է',
        [Locale.En]: 'Task sent',
        [Locale.Pt]: 'Tarefa enviada',
        [Locale.Ge]: 'ამოცანის გაგზავნა',
    },
    whateverYouSeeFit: {
        [Locale.Ru]: 'Всё, что сочтёте нужным',
        [Locale.Am]: 'Այն ամենը, ինչ կհամարեք անհրաժեշտ',
        [Locale.En]: 'Whatever you see fit',
        [Locale.Pt]: 'O que você achar melhor',
        [Locale.Ge]: 'რასაც თქვენ ხედავთ fit',
    },
    anyInformationAboutTask: {
        [Locale.Ru]: 'Любая информация, касающаяся выполнения задания',
        [Locale.Am]: 'Ցանկացած տեղեկություն առաջադրանքի կատարման վերաբերյալ',
        [Locale.En]: 'Any information about task execution',
        [Locale.Pt]: 'Qualquer informação sobre a execução da tarefa',
        [Locale.Ge]: 'ახალი ინფორმაცია ამოცანის გამოყენებისთვის',
    },
    fioEhrDate: {
        [Locale.Ru]: 'ФИО, карта и дата рождения',
        [Locale.Am]: 'Անուն, ազգանուն, հայրանուն, քարտ և ծննդյան ամսաթիվ',
        [Locale.En]: 'Full name, card and date of birth',
        [Locale.Pt]: 'Nome completo, prontuário e data de nascimento',
        [Locale.Ge]: 'სრული სახელი, ბარათი და დაბადების თარიღი',
    },
    executeUrgently: {
        [Locale.Ru]: 'Выполнить срочно',
        [Locale.Am]: 'Կատարել շտապ',
        [Locale.En]: 'Execute urgently',
        [Locale.Pt]: 'Executar com urgência',
        [Locale.Ge]: 'შესრულება სასწრაფოდ',
    },
    selectPatientAndEpisode: {
        [Locale.Ru]: 'Выбрать пациента и эпизод',
        [Locale.Am]: 'Ընտրել պացիենտ և դրվագ',
        [Locale.En]: 'Select patient and episode',
        [Locale.Pt]: 'Selecionar paciente e episódio',
        [Locale.Ge]: 'აირჩიეთ პაციენტი და ეპიზოდი',
    },
    executorsComment: {
        [Locale.Ru]: 'Комментарий исполнителя',
        [Locale.Am]: 'Կատարողի մեկնաբանություն',
        [Locale.En]: `Performer's comment`,
        [Locale.Pt]: 'Comentário do executor',
        [Locale.Ge]: 'მხატვრის კომენტარი',
    },
    createTask: {
        [Locale.Ru]: 'Создать задание',
        [Locale.Am]: 'Ստեղծել առաջադրանք',
        [Locale.En]: 'Create task',
        [Locale.Pt]: 'Criar tarefa',
        [Locale.Ge]: 'შექმნა ამოცანა',
    },
    deleteTask: {
        [Locale.Ru]: 'Удалить задание',
        [Locale.Am]: 'Ջնջել առաջադրանքը',
        [Locale.En]: 'Delete task',
        [Locale.Pt]: 'Excluir tarefa',
        [Locale.Ge]: 'დავალების წაშლა',
    },
    markCompleted: {
        [Locale.Ru]: 'Отметить выполненным',
        [Locale.Am]: 'Նշել որպես կատարված',
        [Locale.En]: 'Mark completed',
        [Locale.Pt]: 'Marcar como concluído',
        [Locale.Ge]: 'Mark დასრულდა',
    },
    markUnfulfilled: {
        [Locale.Ru]: 'Отметить невыполненным',
        [Locale.Am]: 'Նշել որպես չկատարված',
        [Locale.En]: 'Mark unfulfilled',
        [Locale.Pt]: 'Marcar como não cumprido',
        [Locale.Ge]: 'მარკ, როგორც შეუსრულებელი',
    },
    cancelExecution: {
        [Locale.Ru]: 'Отменить выполнение',
        [Locale.Am]: 'Չեղարկել կատարումը',
        [Locale.En]: 'Cancel execution',
        [Locale.Pt]: 'Cancelar execução',
        [Locale.Ge]: 'აღსრულების გაუქმება',
    },
    chooseColleague: {
        [Locale.Ru]: 'Выберите коллегу',
        [Locale.Am]: 'Ընտրեք գործընկերոջը',
        [Locale.En]: 'Choose a colleague',
        [Locale.Pt]: 'Escolher um colega',
        [Locale.Ge]: 'აირჩიე კოლეგა',
    },
    chooseExecutor: {
        [Locale.Ru]: 'Выберите исполнителя',
        [Locale.Am]: 'Ընտրեք կատարողին',
        [Locale.En]: 'Choose an executor',
        [Locale.Pt]: 'Escolher um executor',
        [Locale.Ge]: 'აირჩიე შემსრულებელი',
    },
    choosePractice: {
        [Locale.Ru]: 'Выберите практику',
        [Locale.Am]: 'Ընտրեք պրակտիկան',
        [Locale.En]: 'Choose a practice',
        [Locale.Pt]: 'Escolher uma prática',
        [Locale.Ge]: 'აირჩიე პრაქტიკა',
    },
    newRecommendation: {
        [Locale.Ru]: 'Новая рекомендация',
        [Locale.Am]: 'Նոր հանձնարարական',
        [Locale.En]: 'New recommendation',
        [Locale.Pt]: 'Nova recomendação',
        [Locale.Ge]: 'ახალი რეკომენდაცია',
    },
    editRecommendations: {
        [Locale.Ru]: 'Редактирование рекомендации',
        [Locale.Am]: 'Հանձնարարականի խմբագրում',
        [Locale.En]: 'Editing Recommendations',
        [Locale.Pt]: 'Editar Recomendações',
        [Locale.Ge]: 'რედაქტირება რეკომენდაცია',
    },
    recommendationInfoParagraph: {
        [Locale.Ru]: 'Рекомендации будут видны пациенту в плане лечения в личном кабинете.',
        [Locale.Am]: 'Հանձնարարականները պացիենտին տեսանելի կլինեն բուժման պլանում՝ անձնական հաշվում։',
        [Locale.En]: 'Recommendations will be visible to the patient in the treatment plan in the personal account.',
        [Locale.Pt]: 'As recomendações ficarão visíveis para o paciente no plano de tratamento na conta pessoal.',
        [Locale.Ge]: 'რეკომენდაციები პაციენტისთვის თვალსაჩინო იქნება მკურნალობის გეგმაში პირად ანგარიშზე.',
    },
    recommendationInfoParagraphPartTwo: {
        [Locale.Ru]: 'Используйте рекомендации, чтобы скоординировать план лечения, дать задание пациенту',
        [Locale.Am]: 'Օգտագործեք հանձնարարականները՝ բուժման պլանը համակարգելու, պացիենտին առաջադրանք տալու համար',
        [Locale.En]: 'Use recommendations to coordinate a treatment plan, give a task to the patient',
        [Locale.Pt]: 'Use recomendações para coordenar um plano de tratamento, dar uma tarefa ao paciente',
        [Locale.Ge]: 'გამოიყენეთ რეკომენდაციები მკურნალობის გეგმის კოორდინაციისთვის, მიეცით დავალება პაციენტს',
    },
    recommendationInfoParagraphPartThree: {
        [Locale.Ru]: 'или предупредить пациента о поведении в особых ситуациях.',
        [Locale.Am]: 'կամ պացիենտին նախազգուշացնելու հատուկ իրավիճակներում վարքի մասին։',
        [Locale.En]: 'or warn the patient about behavior in special situations.',
        [Locale.Pt]: 'ou alertar o paciente sobre o comportamento em situações especiais.',
        [Locale.Ge]: 'ან გააფრთხილეთ პაციენტი ქცევის შესახებ განსაკუთრებულ სიტუაციებში.',
    },
    recommendationInfoParagraphPartFour: {
        [Locale.Ru]: 'Важные рекомендации получат дополнительный акцент в плане лечения.',
        [Locale.Am]: 'Կարևոր հանձնարարականները բուժման պլանում կստանան լրացուցիչ շեշտադրում։',
        [Locale.En]: 'Important recommendations will receive additional emphasis in the treatment plan.',
        [Locale.Pt]: 'Recomendações importantes receberão ênfase adicional no plano de tratamento.',
        [Locale.Ge]: 'მნიშვნელოვანი რეკომენდაციები მიიღებს დამატებით აქცენტს მკურნალობის გეგმაში.',
    },
    essenceOfRecommendation: {
        [Locale.Ru]: 'Суть рекомендации',
        [Locale.Am]: 'Հանձնարարականի էությունը',
        [Locale.En]: 'The essence of the recommendation',
        [Locale.Pt]: 'A essência da recomendação',
        [Locale.Ge]: 'რეკომენდაციის არსი',
    },
    favoriteRecommendationInfo: {
        [Locale.Ru]: 'Создавайте шаблоны рекомендаций для типовых назначений.\n При добавлении в план лечения рекомендация будет назначаться с сегодняшнего дня.',
        [Locale.Am]: 'Ստեղծեք հանձնարարականների ձևանմուշներ տիպային նշանակումների համար։\n Բուժման պլանում ավելացնելիս հանձնարարականը կնշանակվի այսօրվանից։',
        [Locale.En]: 'Create recommendation templates for typical assignments.\n When added to the treatment plan, the recommendation will be assigned from today.',
        [Locale.Pt]: 'Crie modelos de recomendação para atribuições típicas.\\n Quando adicionada ao plano de tratamento, a recomendação será atribuída a partir de hoje.',
        [Locale.Ge]: 'შექმენით სარეკომენდაციო შაბლონები ტიპიური დავალებებისთვის.\\n მკურნალობის გეგმას რომ დაემატება, რეკომენდაცია დღეიდან დაინიშნება.',
    },
    createNewRecommendation: {
        [Locale.Ru]: 'Создать новую рекомендацию',
        [Locale.Am]: 'Ստեղծել նոր հանձնարարական',
        [Locale.En]: 'Create a new recommendation',
        [Locale.Pt]: 'Criar uma nova recomendação',
        [Locale.Ge]: 'შექმენით ახალი რეკომენდაცია',
    },
    editReferral: {
        [Locale.Ru]: 'Редактирование направления',
        [Locale.Am]: 'Ուղեգրի խմբագրում',
        [Locale.En]: 'Edit referral',
        [Locale.Pt]: 'Editar encaminhamento',
        [Locale.Ge]: 'რედაქტირება მიმართულებით',
    },
    detailsThatWillHelpYou: {
        [Locale.Ru]: 'Подробности, которые помогут точнее выполнить ваше направление',
        [Locale.Am]: 'Մանրամասներ, որոնք կօգնեն ավելի ճշգրիտ կատարել ձեր ուղեգիրը',
        [Locale.En]: 'Details that will help you more accurately fulfill your referral',
        [Locale.Pt]: 'Detalhes que o ajudarão a cumprir sua indicação com mais precisão',
        [Locale.Ge]: 'დეტალები, რომლებიც დაგეხმარებათ უფრო ზუსტად შეასრულოთ თქვენი მიმართულება',
    },
    appointmentDate: {
        [Locale.Ru]: 'Дата назначения',
        [Locale.Am]: 'Նշանակման ամսաթիվ',
        [Locale.En]: 'Appointment date',
        [Locale.Pt]: 'Data da consulta',
        [Locale.Ge]: 'Appointment date',
    },
    cancellationDate: {
        [Locale.Ru]: 'Дата отмены',
        [Locale.Am]: 'Չեղարկման ամսաթիվ',
        [Locale.En]: 'Cancellation date',
        [Locale.Pt]: 'Data de cancelamento',
        [Locale.Ge]: 'Cancellation date',
    },
    whoCancelled: {
        [Locale.Ru]: 'Кто отменил',
        [Locale.Am]: 'Ով է չեղարկել',
        [Locale.En]: 'Who canceled',
        [Locale.Pt]: 'Quem cancelou',
        [Locale.Ge]: 'Who canceled',
    },
    reasonForCancellation: {
        [Locale.Ru]: 'Причина отмены',
        [Locale.Am]: 'Չեղարկման պատճառ',
        [Locale.En]: 'Reason for cancellation',
        [Locale.Pt]: 'Motivo do cancelamento',
        [Locale.Ge]: 'Reason for cancellation',
    },
    endOfTherapy: {
        [Locale.Ru]: 'Конец терапии',
        [Locale.Am]: 'Թերապիայի ավարտ',
        [Locale.En]: 'End of therapy',
        [Locale.Pt]: 'Fim da terapia',
        [Locale.Ge]: 'End of therapy',
    },
    yourAnsweredReferral: {
        [Locale.Ru]: 'Вы ответили на это направление',
        [Locale.Am]: 'Դուք պատասխանել եք այս ուղեգրին',
        [Locale.En]: 'You answered this referral',
        [Locale.Pt]: 'Você respondeu a esta referência',
        [Locale.Ge]: 'You answered this referral',
    },
    cancelReplay: {
        [Locale.Ru]: 'Снять ответ',
        [Locale.Am]: 'Հանել պատասխանը',
        [Locale.En]: 'Cancel reply',
        [Locale.Pt]: 'Cancelar resposta',
        [Locale.Ge]: 'Cancel reply',
    },
    patientWillNotSeeTask: {
        [Locale.Ru]: 'Это задание не увидит пациент.',
        [Locale.Am]: 'Այս առաջադրանքը պացիենտը չի տեսնի։',
        [Locale.En]: 'The patient will not see this task.',
        [Locale.Pt]: 'O paciente não verá esta tarefa.',
        [Locale.Ge]: 'The patient will not see this task.',
    },
    pleaseUseTask: {
        [Locale.Ru]: 'Используйте задания, чтобы не забыть о коммуникации с пациентом, о проверке состояния или других\n событий, о которых надо напомнить.',
        [Locale.Am]: 'Օգտագործեք առաջադրանքները, որպեսզի չմոռանաք պացիենտի հետ հաղորդակցության, վիճակի ստուգման կամ այլ\n իրադարձությունների մասին, որոնց մասին պետք է հիշեցնել։',
        [Locale.En]: 'Use tasks to remember to communicate with the patient, check the condition, or other\n events that need to be recalled.',
        [Locale.Pt]: 'Use tarefas para lembrar de se comunicar com o paciente, verificar a condição ou outros\\n eventos que precisam ser lembrados.',
        [Locale.Ge]: 'Use tasks to remember to communicate with the patient, check the condition, or other\n events that need to be recalled.',
    },
    programConditions: {
        [Locale.Ru]: 'Условия программы',
        [Locale.Am]: 'Ծրագրի պայմաններ',
        [Locale.En]: 'Program conditions',
        [Locale.Pt]: 'Condições do programa',
        [Locale.Ge]: 'Program conditions',
    },
    previouslyReferral: {
        [Locale.Ru]: 'Назначенное ранее направление',
        [Locale.Am]: 'Նախկինում նշանակված ուղեգիր',
        [Locale.En]: 'Previously assigned referral',
        [Locale.Pt]: 'Referência atribuída anteriormente',
        [Locale.Ge]: 'Previously assigned referral',
    },
    newValue: {
        [Locale.Ru]: 'Новое значение',
        [Locale.Am]: 'Նոր արժեք',
        [Locale.En]: 'New value',
        [Locale.Pt]: 'Novo valor',
        [Locale.Ge]: 'New value',
    },
    previousValues: {
        [Locale.Ru]: 'Предыдущие значения',
        [Locale.Am]: 'Նախորդ արժեքներ',
        [Locale.En]: 'Previous values',
        [Locale.Pt]: 'Valores anteriores',
        [Locale.Ge]: 'Previous values',
    },
    failReferralDelete: {
        [Locale.Ru]: 'Не удалось удалить направления',
        [Locale.Am]: 'Չհաջողվեց ջնջել ուղեգրերը',
        [Locale.En]: 'Failed to delete referral',
        [Locale.Pt]: 'Falha ao excluir referência',
        [Locale.Ge]: 'Failed to delete referral',
    },
    hasReservation: {
        [Locale.Ru]: 'Есть бронь',
        [Locale.Am]: 'Կա ամրագրում',
        [Locale.En]: 'Has reservation',
        [Locale.Pt]: 'Tem reserva',
        [Locale.Ge]: 'Has reservation',
    },
    createReservation: {
        [Locale.Ru]: 'Создать бронь',
        [Locale.Am]: 'Ստեղծել ամրագրում',
        [Locale.En]: 'Create reservation',
        [Locale.Pt]: 'Criar reserva',
        [Locale.Ge]: 'Create reservation',
    },
    episodeManager: {
        [Locale.Ru]: 'Менеджер эпизода',
        [Locale.Am]: 'Էպիզոդի մենեջեր',
        [Locale.En]: 'Episode Manager',
        [Locale.Pt]: 'Gestor de Episódios',
        [Locale.Ge]: 'Episode Manager',
    },
    deviceTaskAlreadyQueued: {
        [Locale.Ru]: 'Задание по этому направлению уже в очереди',
        [Locale.Am]: 'Այս ուղեգրով առաջադրանքն արդեն հերթում է',
        [Locale.En]: 'The task for this referral is already queued',
        [Locale.Pt]: 'A tarefa para este encaminhamento já está na fila',
        [Locale.Ge]: 'ამ მიმართვის დავალება უკვე რიგშია',
    },
    deviceTaskAlreadyQueuedForService: {
        [Locale.Ru]: 'Задание по этой услуге уже в очереди',
        [Locale.Am]: 'Այս ծառայությամբ առաջադրանքն արդեն հերթում է',
        [Locale.En]: 'The task for this service is already queued',
        [Locale.Pt]: 'A tarefa para este serviço já está na fila',
        [Locale.Ge]: 'ამ სერვისის დავალება უკვე რიგშია',
    },
    deviceTaskSentToDeviceBanner: {
        [Locale.Ru]: 'Задание было отправлено на прибор',
        [Locale.Am]: 'Առաջադրանքն ուղարկվել է սարքին',
        [Locale.En]: 'The task has been sent to the device',
        [Locale.Pt]: 'A tarefa foi enviada para o dispositivo',
        [Locale.Ge]: 'დავალება გაიგზავნა მოწყობილობაზე',
    },
    deviceTaskSentToDeviceButton: {
        [Locale.Ru]: 'Задание отправлено на прибор',
        [Locale.Am]: 'Առաջադրանքն ուղարկվել է սարքին',
        [Locale.En]: 'The task is sent to the device',
        [Locale.Pt]: 'A tarefa foi enviada para o dispositivo',
        [Locale.Ge]: 'დავალება გაგზავნილია მოწყობილობაზე',
    },
    deviceTaskDelete: {
        [Locale.Ru]: 'Удалить задание',
        [Locale.Am]: 'Հեռացնել առաջադրանքը',
        [Locale.En]: 'Delete the task',
        [Locale.Pt]: 'Excluir a tarefa',
        [Locale.Ge]: 'დავალების წაშლა',
    },
    deviceTaskSending: {
        [Locale.Ru]: 'Отправляем задание...',
        [Locale.Am]: 'Ուղարկում ենք առաջադրանքը...',
        [Locale.En]: 'Sending the task...',
        [Locale.Pt]: 'Enviando a tarefa...',
        [Locale.Ge]: 'იგზავნება დავალება...',
    },
    deviceTaskSendFailed: {
        [Locale.Ru]: 'Не удалось отправить задание',
        [Locale.Am]: 'Չհաջողվեց ուղարկել առաջադրանքը',
        [Locale.En]: 'Failed to send the task',
        [Locale.Pt]: 'Não foi possível enviar a tarefa',
        [Locale.Ge]: 'დავალების გაგზავნა ვერ მოხერხდა',
    },
    deviceTaskSentToDeviceRow: {
        [Locale.Ru]: 'Отправлено на прибор',
        [Locale.Am]: 'Ուղարկվել է սարքին',
        [Locale.En]: 'Sent to the device',
        [Locale.Pt]: 'Enviado para o dispositivo',
        [Locale.Ge]: 'გაგზავნილია მოწყობილობაზე',
    },
    $deviceWithOffice: {
        [Locale.Ru]: '$device · кабинет $office',
        [Locale.Am]: '$device · սենյակ $office',
        [Locale.En]: '$device · office $office',
        [Locale.Pt]: '$device · sala $office',
        [Locale.Ge]: '$device · ოთახი $office',
    },
};
